import { render, staticRenderFns } from "./reportType.vue?vue&type=template&id=52b905ec&"
import script from "./reportType.vue?vue&type=script&lang=js&"
export * from "./reportType.vue?vue&type=script&lang=js&"
import style0 from "./reportType.vue?vue&type=style&index=0&id=52b905ec&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports